import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export const DefineDastresi = new Vuex.Store({
  state: {
    treeDefineDastresi_GrpShobe: [],
    treeDefineDastresi_DastresiGrp: [],
    Data_UpdateDastresi: {},
    RenderList2: true,
  },
  mutations: {},
  actions: {},
  getters: {},
});
